<template>
    <div class="bind-wrap">
        <div class="title">
            <div class="top">
                <img src="../../assets/loginlogo2.png" alt class="img"/>
                <div style="margin-left: 15px">
                    <h2 class="large-title">智慧物联</h2>
                    <div class="small-title">共享物联/IoT+大数据</div>
                </div>
            </div>
        </div>
        <div class="title">
            <Form @submit="login">
                <Field required clearable left-icon="user-o" placeholder="请输入用户名" v-model="username"/>
                <Field :style="{'display':spcp?'none':''}"
                       required
                       clearable
                       left-icon="goods-collect-o"
                       placeholder="请输入密码"
                       right-icon="closed-eye"
                       @click-right-icon="showPsw"
                       v-model="password"
                       type="password"
                />
                <Field :style="{'display':!spcp?'none':''}"
                       required
                       clearable
                       left-icon="goods-collect-o"
                       placeholder="请输入密码"
                       right-icon="eye-o"
                       @click-right-icon="hidePsw"
                       v-model="password"
                />
                <div style="text-align: right;margin-right: 12px;margin-top: 10px;cursor: pointer;color:#1890ff">
                    <span @click="forget">忘记密码</span></div>
                <Button type="info" style="width: 95% ; margin: 30px auto;" @click="login" block>登&nbsp;&nbsp;&nbsp;录</Button>
            </Form>
        </div>
    </div>
</template>

<script>
    import storage from "@/utils/storage";
    import store from "@/store"
    import {isWechat} from "@/utils/tool"
    import {Button, Field, Form} from "vant";

    export default {
        components: {
            Field,
            Button, Form
        },
        props: {},
        data() {
            return {
                username: '',
                password: '',
                phone: null,
                spcp: false,
            };
        },
        computed: {},
        created() {
        },
        mounted() {
            store.dispatch({type: 'global/reset'})
        },
        methods: {
            login() {
                const data = {username: this.username, password: this.password, type: "CLUSTER"}
                if(data.username === ``){
                    this.$toast.fail("用户名为空")
                }else if(data.password === ``){
                    this.$toast.fail("密码为空")
                }else if (!isWechat()) {
                    this.$http.wechat.getToken(data)
                        .then(ret => {
                            if (ret) {
                                storage.setCache("headers", {
                                    Authorization: ret.token_type + " " + ret.access_token
                                });
                                storage.setCache("accessToken", ret.access_token);
                                this.$router.push("/");
                            }
                        })
                } else {
                    this.$http.wechat.association(data)
                        .then(ret => {
                            console.error('绑定成功', ret)
                            if (ret) {
                                this.$router.push("/");
                            }
                        })
                }
            },
            showPsw() {
                this.spcp = true;
            },
            hidePsw() {
                this.spcp = false;
            },
            forget() {
                this.$router.push('/account/forget/')
            },
            timeDown() {
                let result = setInterval(() => {
                    this.second--;
                    console.log("定时器", this.second);
                    if (this.second < 0) {
                        clearInterval(result);
                        this.sending = false;
                        this.disabled = false;
                        this.second = 60;
                    }
                }, 1000);
            }
        },
        watch: {},
    };
</script>

<style lang="less" scoped>
    .bind-wrap {
        .van-cell {
            padding: 15px 16px;
        }
        .title {
            padding-top: 8px;
        }

        .large-title {
            font-size: 25px;
            font-weight: 500
        }

        .small-title {
            font-size: 16px;
            margin-top: -15px
        }

        .img {
            width: 100px;
            height: 100px
        }

        .top {
            display: flex;
            flex-direction: row;
            padding-left: 10px;
            padding-bottom: 8px;
        }
    }

</style>
